import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {
  getBetLoopUserProfileById,
  getPrincipleBetLoopUserProfile,
  getPrincipleBetLoopUserProfileStats,
} from './api'
import { isBetLoopProblemResponse } from './api/typeGuards'

export const betLoopPrincipleProfileQuery = queryOptions({
  queryKey: queryKeys.betLoopAccountProfileBase,
  queryFn: getPrincipleBetLoopUserProfile,
  staleTime: 10 * 60 * 1000,
  refetchOnMount: true,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  gcTime: 30 * 60 * 1000,
})

export const betLoopProfileStatsByIdQuery = (id: string) =>
  queryOptions({
    queryKey: [...queryKeys.betLoopAccountProfileStats, id],
    queryFn: () => getPrincipleBetLoopUserProfileStats(id),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    gcTime: 1_000 * 60 * 30, // 30min
  })

export const betLoopProfileByIdQuery = (id: string) =>
  queryOptions({
    queryKey: [...queryKeys.betLoopAccountProfileBase, id],
    queryFn: () => getBetLoopUserProfileById(id),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    gcTime: 1_000 * 60 * 30, // 30min
    retry: (failureCount, error) => {
      if (isBetLoopProblemResponse(error) && error.isBanned) {
        return false
      }
      return failureCount < 3
    },
  })
